import { Box } from "@mui/material";
import { observer } from "mobx-react-lite";
import PricingContent from "../../components/Popups/Pricing/PricingContent/PricingContent.tsx";
import { useAppStore } from "../../hooks/useStores.tsx";
import { OrgSubscriptionPlan } from "../../models/billing.ts";
import styles from "./Pricing.module.scss";

const PricingPage = () => {
	const { pricingStore } = useAppStore();

	const handlePlanClick = (plan: OrgSubscriptionPlan) => {
		pricingStore.openPricingFlow();
		pricingStore.handlePlanButtonClick(plan);
	};

	return (
		<>
			{/*<Header />*/}
			<Box className={styles.pricingPageContainer}>
				<PricingContent isPublicPage={true} onPlanClick={handlePlanClick} />
			</Box>
			{/*<PricingFlow />*/}
		</>
	);
};

export default observer(PricingPage);
